import { apolloProvider } from '@/apollo-provider.js'
import { QUERY_UNITS } from './graphql'
import { GET_UNIT_GROUPS } from '@/modules/configuracoes/lojas/graphql'
import sortBy from 'lodash/sortBy'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import { sanitizeUnits } from '@/helpers/units'

export default {
  selectUnits({ commit }, units) {
    commit('SET_SELECTED_UNITS', units)
  },
  async fetchUnitsGroups({ commit }) {
    await apolloProvider.defaultClient
      .query({
        query: GET_UNIT_GROUPS,
        fetchPolicy: 'no-cache',
      })
      .then(({ data: { unitGroups } }) => {
        commit('SET_UNITS_GROUPS', cloneDeep(unitGroups.unit_groups))
      })
  },
  async fetchUnits({ state, commit, dispatch }, isUpdate = true) {
    if (!isEmpty(state.units) && !isUpdate) return

    await apolloProvider.defaultClient
      .query({
        query: QUERY_UNITS,
        fetchPolicy: 'no-cache',
      })
      .then(({ data }) => {
        commit('SET_UNITS', cloneDeep(sanitizeUnits(data.units)))
        dispatch('setTagList', cloneDeep(sanitizeUnits(data.units)))
      })
  },
  setUnavailableUnits({ commit }, units) {
    commit('SET_UNAVAILABLE_UNITS_IDS', units)
  },
  setUnit({ commit }, unit) {
    commit('SET_UNIT', unit)
  },
  setTagList({ commit }, units) {
    const list = units
      .map((unit) => {
        if (unit.tags && unit.tags.length > 0) {
          return unit.tags
        }
      })
      .filter((item) => item !== undefined)
    const tagList = []
    for (let i in list) {
      for (let j in list[i]) {
        if (!tagList.map((item) => item.name).includes(list[i][j].name)) {
          tagList.push(list[i][j])
        }
      }
    }
    commit(
      'SET_TAG_LIST',
      sortBy(tagList, (item) => item.name.toLowerCase())
    )
  },
}
